module.exports = __webpack_public_path__ + "assets/a1aa4aeb8c0e8a1232b35d6a1b0bae5e.mp3";